import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Servicio para manejar localStorage de forma segura en SSR
 * Verifica si está en el navegador antes de acceder a localStorage
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Guarda un valor en localStorage
   * @param key - Clave para almacenar el valor
   * @param value - Valor a almacenar
   */
  setItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error(`Error saving to localStorage: ${key}`, error);
      }
    }
  }

  /**
   * Obtiene un valor de localStorage
   * @param key - Clave del valor a obtener
   * @returns El valor almacenado o null si no existe o no está en navegador
   */
  getItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      try {
        return localStorage.getItem(key);
      } catch (error) {
        console.error(`Error reading from localStorage: ${key}`, error);
        return null;
      }
    }
    return null;
  }

  /**
   * Elimina un valor de localStorage
   * @param key - Clave del valor a eliminar
   */
  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error(`Error removing from localStorage: ${key}`, error);
      }
    }
  }

  /**
   * Limpia todo el localStorage
   */
  clear(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.clear();
      } catch (error) {
        console.error('Error clearing localStorage', error);
      }
    }
  }

  /**
   * Verifica si una clave existe en localStorage
   * @param key - Clave a verificar
   * @returns true si la clave existe, false en caso contrario
   */
  hasItem(key: string): boolean {
    return this.getItem(key) !== null;
  }
}





